import { useMemo } from 'react';
import { MANAGER_ID, OWNER_ID } from '@spike/model';
import { useAuth } from './useAuth';

export interface UseRolesResult {
    isOwner: boolean;
    isManager: boolean;
}

export const useRoles = (): UseRolesResult => {
    const auth = useAuth();

    return useMemo(() => {
        const roleId = auth?.user?.role?.id;
        return {
            isOwner: roleId === OWNER_ID,
            isManager: roleId === MANAGER_ID
        };
    }, [auth?.user?.role?.id]);
};

export default useRoles;
